module.exports = __webpack_public_path__ + "static/media/Flecha.31dfdb66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/SupervisorChat/Flecha.svg
// module id = 1831
// module chunks = 0